import {
  DeleteRequest,
  GetRequest,
  PostRequest,
  PutRequest,
} from "../../plugins/https";
import {
  getDownload,
  getOneDownload,
  setDownload,
  updateDownloadData,
} from "./action";
import {
  DELETE_DOWNLAOD,
  GET_DOWNLOAD,
  GET_ONE_DOWNLOAD,
  SET_DOWNLOAD,
  UPDATE_DOWNLOAD,
} from "./actionType";

export const getDownloadData = async (dispatch) => {
  try {
    const res = await GetRequest("/download");
    dispatch(getDownload(res.data));
  } catch (error) {
    console.error(error);
  }
};

export const addDownload = (Download) => async (dispatch) => {
  try {
    const res = await PostRequest("/download", Download);
    dispatch(setDownload(res.data));
    dispatch(getDownloadData);
  } catch (error) {
    console.error(error);
  }
};

export const getOneDownloadData = (id) => async (dispatch) => {
  try {
    const res = await GetRequest(`/download/${id}`);
    dispatch(getOneDownload(res.data));
  } catch (error) {
    console.error(error);
  }
};

export const deleteDownload = (id) => async (dispatch) => {
  try {
    const res = await DeleteRequest(`/download/${id}`);
    // dispatch(deleteDownload(id));
  } catch (error) {
    console.error("Error in deleting Download: ", error);
  }
};

export const updateDownload = (id, updateDownloaded) => async (dispatch) => {
  try {
    const res = await PutRequest(`/download/${id}`, updateDownloaded);
    dispatch(updateDownloadData(res.data));
    getDownloadData(dispatch);
  } catch (error) {
    console.error("Error in updating download: ", error);
  }
};

const initialState = {
  download: "",
  downloadData: [],
  OneDownloadData: [],
};

export const downloadReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DOWNLOAD:
      return {
        ...state,
        download: action.payload,
      };
    case GET_DOWNLOAD:
      return {
        ...state,
        downloadData:
          action.payload && action.payload.data
            ? action.payload.data
            : action.payload,
      };
    case DELETE_DOWNLAOD:
      return {
        ...state,
        downloadData: state.downloadData.filter(
          (item) => item.id !== action.payload,
        ),
      };
    case UPDATE_DOWNLOAD:
      return {
        ...state,
        downloadData: state.downloadData.map((item) =>
          item.id === action.payload.id ? { ...item, ...action.payload } : item,
        ),
      };
    case GET_ONE_DOWNLOAD:
      return {
        ...state,
        OneDownloadData:
          action.payload && action.payload.data
            ? action.payload.data
            : action.payload,
      };
    default:
      return state;
  }
};
